module.exports = __webpack_public_path__ + "img/integrations-wordpress.6e8c5d8b.png";